<template>
  <div class="dem-rel-con">
    <!-- SETA O STATUS DA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else>
      <template v-if="[ '', null, undefined ].indexOf(cpntFiltros) !== -1">
        <div class="app-fil-rel-nov">
          <table>
            <tr class="n-col-1">
              <td>
                <App-Filtro-Relatorio
                :cpntTipo="'seletor-data'"
                :cpntNome="''"
                :cpntTodos="'Todas as datas'"
                :cpntValue="filtros.dat"
                @UPDATE_VALUE_FILTRO="(value) => { demRelConsolidadoPgtoAtualizarFiltro(value, 'dat') }"
                ref="dat"
                ></App-Filtro-Relatorio>
              </td>
            </tr>
          </table>
  
          <table>
            <tr :class="'n-col-' + demRelConsolidadoPgtoContarColunasLinha1">
              <td :colspan="(4 - demRelConsolidadoPgtoContarColunasLinha1)">
                <App-Filtro-Relatorio
                :cpntTipo="'autocomplite'"
                :cpntTabela="[ { nome: 'Documento', chave: 'cnpj_cpf' }, { nome: 'Nome', chave: 'nome' } ]"
                :cpntKeyValue="'id'"
                :cpntKeyMostra="[ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]"
                :cpntNome="'Contatos'"
                :cpntTodos="'Todos'"
                :cpntValue="filtros.con"
                :cpntNenhum="false"
    
                :cpntRouter="'/contato/get'"
                :cpntMethod="'POST'"
                :cpntField="{ id: null, nome: null, empresa: null, cnpj_cpf: null }"
                :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }"
                @UPDATE_VALUE_FILTRO="(value) => { demRelConsolidadoPgtoAtualizarFiltro(value, 'con') }"
                ref="con"
                ></App-Filtro-Relatorio>
              </td>
              <td v-if="permissoes.vei === true">
                <App-Filtro-Relatorio
                :cpntTipo="'autocomplite'"
                :cpntTabela="[ { nome: 'Placa', chave: 'placa' }, { nome: 'Marca', chave: 'id_mar_nome' }, { nome: 'Modelo', chave: 'id_mod_nome' } ]"
                :cpntKeyValue="'id'"
                :cpntKeyMostra="[ 'demandaId_id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ]"
                :cpntNome="'Veículo'"
                :cpntTodos="'Todos'"
                :cpntValue="filtros.vei"
                :cpntNenhum="true"
    
                :cpntRouter="'/veiculo/get'"
                :cpntMethod="'POST'"
                :cpntField="{ id: null, placa: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }"
                :cpntWhere="{ aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }"
                @UPDATE_VALUE_FILTRO="(value) => { demRelConsolidadoPgtoAtualizarFiltro(value, 'vei') }"
                ref="vei"
                ></App-Filtro-Relatorio>
              </td>
              <td v-if="permissoes.pet === true">
                <App-Filtro-Relatorio
                :cpntTipo="'autocomplite'"
                :cpntTabela="[ { nome: 'Nome', chave: 'nome' }, { nome: 'Raça', chave: 'id_pet_subespecie_nome' } ]"
                :cpntKeyValue="'id'"
                :cpntKeyMostra="[ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'demandaId_id_con_nome' ]"
                :cpntNome="'Pet'"
                :cpntTodos="'Todos'"
                :cpntValue="filtros.pet"
                :cpntNenhum="true"
    
                :cpntRouter="'/pet/get'"
                :cpntMethod="'POST'"
                :cpntField="{ id: null, nome: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }"
                :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }"
                @UPDATE_VALUE_FILTRO="(value) => { demRelConsolidadoPgtoAtualizarFiltro(value, 'pet') }"
                ref="pet"
                ></App-Filtro-Relatorio>
              </td>
            </tr>
          </table>
        </div>
  
        <!-- SETA O BOTÃO PESQUISAR -->
        <div class="dem-rel-con-pes">
          <App-Button :cpntStatus="pesquisa === 'carregando' ? pesquisa: ''" :cpntClass="'btn btn-primary'" @onClick="() => { demRelConsolidadoPgtoPesquisar() }">Pesquisar</App-Button>
        </div>
      </template>

      <!-- SETA O RESULTADO DA TELA -->
      <div class="dem-rel-con-res" v-if="pesquisa !== null">
        <div v-if="grafico !== null && linhas.length >= 1" class="grafico">
          <canvas ref="grafico" width="1000" height="300" style="position: relative;"></canvas>
        </div>

        <App-Tabela
        :cpntKeyValueEditar="'id_pgto'"
        :cpntStatus="''"
        :cpntLinha="linhas"
        :cpntColuna="colunas"
        :cpntApiRouter="router"
        :cpntApiMethods="method"
        :cpntApiMontarQueryGet="demRelConsolidadoPgtoMontarQueryGet"
        :cpntSetarValores="demRelConsolidadoPgtoTabSetarLinhas"
        :cpntApiBuscaComplementar="demRelConsolidadoPgtoBuscaPdv"
        :cpntApiEstruturaQueryGet="[ [ 'type', 'limit', 'field', 'where', 'order', 'group', 'SemPaginacao' ] ]"
        ref="tabela"
        ></App-Tabela>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dem-rel-con-pes {
    text-align: center;
    margin: 10px 0px;
  }
  .dem-rel-con-res > div {
    padding: 10px 0px;
  }
    .dem-rel-con-res > .grafico > div {
      width: 200px;
      margin-left: 15px;
      margin-bottom: 15px;
    }

    .dem-rel-con-res > .grafico > div > canvas {
      width: 100% !important;
      max-width: 800px !important;
    }

    .dem-rel-con-res > .nenhum-reg {
      text-align: center;
    }
    .dem-rel-con-res > .cpnt-tabela {
      width: 600px;
      margin: 0px auto;
    }

    .dem-rel-con-res > .resumo {
      background: #f9f9f9;
      width: 700px;
      margin: 0px auto;
      border: 1px solid #ccc;
      border-radius: 5px;
      border-collapse: separate;
    }
    .dem-rel-con-res > .resumo > tr > td {
      text-align: center;
      padding: 2px 10px;
      /* border: 1px solid #ccc; */
    }
    .dem-rel-con-res > .resumo > tr:first-child > td {
      padding-top: 10px;
    }
    .dem-rel-con-res > .resumo > tr:last-child > td {
      padding-bottom: 10px;
    }
  .dem-rel-con-res > div > .btcon {
    text-align: left;
    border: 1px solid #d5dee5;
    padding: 5px;
    /* margin: 5px; */
    border-radius: 2px;
    font-size: 11px;
    background-color: #f4f9fe;
    text-decoration: none;
    color: #333;
  }
  .dem-rel-con-res > div > .btcon.ocultar_dados {
    border-bottom: 0px !important;
  }

  .dem-rel-con-res > div > .btcon > button {
    /* display: inline-block; */
    width: max-content !important;
    min-width: 200px !important;
    text-align: left !important;

    margin: 3px 0px !important;
    padding: 0px 40px 0px 0px !important;
    text-decoration: none !important;
    /* font-size: var(--font-base-soma-17); */
    font-size: calc(100% + 2px) !important;
  }
  .dem-rel-con-res > div > .btcon > table {
    width: 500px;
    float: right;
    margin-top: 4px;
  }
  .dem-rel-con-res > div > .btcon.ocultar_dados > table > tr > td:not(.olho) {
    visibility: hidden;
  }
  .dem-rel-con-res > div > .btcon > table > tr > td:not(.olho) {
    text-align: center;
    width: calc((100% - 50px) / 4);
  }
  .dem-rel-con-res > div > .btcon > .olho {
    width: 50px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    width: 50px;
    vertical-align: -5px;
  }
  .dem-rel-con-res > div > .btcon > .olho > span > svg {
    font-size: 18px;
  }
</style>

<style>
  .dem-rel-con-res > .cpnt-tabela > tbody > tr > td:first-child {
    font-size: calc(100% + 2px);
    padding: 6px 4px !important;
  }
  .dem-rel-con-res > .cpnt-tabela > tbody > tr > td:last-child {
    font-size: calc(100% + 1px);
    padding: 6px 4px !important;
  }
  .dem-rel-con-res > .cpnt-tabela > tbody > tr:last-child > td {
    font-weight: bold;
  }

  .dem-rel-con-res > .grafico > canvas {
    width: 100% !important;
    max-width: 800px !important;
    margin: 0px auto;
  }
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        requeire: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Minha-Personalizacao': () => import('@/components/_geral/Minha-Personalizacao.vue'),
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Demanda-Relatorio-Por-Contato-Tabela': () => import('@/components/demanda/Relatorio/Demanda-Relatorio-Por-Contato-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        grafico: null,
        pesquisa: null,
        tpPesquisa: '',
        forPagamento: null,
        colunas: [],
        linhas: [],
        mper: {
          tabper: '',
          rpp: true,
          order: true,
          orderOptions: [],
          field: true,
          fieldOptions: [],
          filtro: false,
        },
        permissoes: {
          vei: false,
          pet: false,
          pro: false,
          ser: false
        },
        filtros: {
          dem_sta: [ '2' ],
          dat: '40',
          tpD: '0',
          con: '',
          pet: '',
          vei: '',
          pro: '',
          pro_cat: '',
          pro_mar: '',
          ser: '',
          ser_cat: ''
        },
        router: '',
        method: ''
      }
    },
    mounted: function () {
      this.demRelConsolidadoPgtoIniciar()
    },
    methods: {
      demRelConsolidadoPgtoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelConsolidadoPgtoIniciar: function () {
        // SETA O STATUS DA TELA
        this.demRelConsolidadoPgtoSetarStatusGeral('carregando')

        // // INICIA A VARIAVEL 
        // var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // // SETA OS CAMPOS QUE DEVE RETORNAR
        // queryGet.field = { id: null, nome: null }

        // // SETA A ORDENAÇÃO DA TABELA
        // queryGet.order = { nome: 'asc' }

        // // CHAMA FUNÇÃO PARA COMUNICAR COM API
        // this.$store.state.comunicaAPI('/financeiro/config/for-pagamento/get', 'POST', queryGet, (retorno) => {
        //   // SETA OS DADOS RECEBIDOS
        //   this.forPagamento = retorno.data

        //   // LIMPA AS VARIAVEIS
        //   this.mper.tabper = ''
        //   this.mper.rpp = false
        //   this.mper.order = false
        //   this.mper.field = true
        //   this.mper.fieldOptions = [
        //     // { mPer: 1, chave: 'vcto_pgto_ptbr',   nome: 'Data'       },
        //     { mPer: 0, chave: 'id',           nome: 'Cod. Pgto'       },
        //     { mPer: 2, chave: 'nome',         nome: 'Nome'       },
        //     { mPer: 1, chave: '_valor_sum',   nome: 'Valor'      }
        //   ]

        //   // v-if="[ '', null, undefined ].indexOf(cpntFiltros) === -1"

        //   // FAZ AS VERIFICAÇÕES DE PERMISSOES
        //   this.demRelConsolidadoPgtoVerificarPermissao()

        //   // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        //   if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
        //     this.proRelEstTabReiniciar()
        //   } else if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
        //     this.demRelConsolidadoPgtoSetarStatusGeral('')

        //     this.demRelConsolidadoPgtoPesquisar()
        //   } else {
        //     this.demRelConsolidadoPgtoSetarStatusGeral('')
        //   }
        // }, this.demRelConsolidadoPgtoSetarStatusGeral)

        this.colunas = [
          // { mPer: 1, chave: 'vcto_pgto_ptbr',   nome: 'Data'       },
          { mPer: 0, chave: 'id',             nome: 'Cod. Pgto'       },
          { mPer: 2, chave: 'id_pgto_nome',   nome: 'Nome'       },
          { mPer: 1, chave: '_valor_sum',     nome: 'Valor'      }
        ]

        // FAZ AS VERIFICAÇÕES DE PERMISSOES
        this.demRelConsolidadoPgtoVerificarPermissao()

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
          this.proRelEstTabReiniciar()
        } else if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
          this.demRelConsolidadoPgtoSetarStatusGeral('')

          this.demRelConsolidadoPgtoPesquisar()
        } else {
          this.demRelConsolidadoPgtoSetarStatusGeral('')
        }
      },
      demRelConsolidadoPgtoBuscaPdv: function (linhas, callback) {       
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 16 ], null, null, null, null, null, false) === true) {
          // INICIA A QUERY
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }
  
          // SETA OS FILDES RECEBIDOS
          queryGet.field = {
            id: null,
            cod_venda: { j: { vencimento: { a: 'vcto_pgto_ptbr' } } },
            // id_pgto: null,
            id_pgto: { j: { nome: null } },
            valor: { o: 'sum' }
          }
          
          // CHAMA A FUNÇÃO PARA MONTAR O WHERE
          queryGet.where = this.demRelConsolidadoPgtoMontarWhere(true)
  
          // SETA O ORDENAÇÃO DA PEQUISA
          queryGet.order = this.demRelConsolidadoPgtoMontarOrder()
  
          // CHAMA A FUNÇÃO PARA MONTAR O 
          queryGet.group = this.demRelConsolidadoPgtoMontarGroup()

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/venda/produto/pdv/pagamento/get', 'POST', queryGet, (retorno) => {
            for (var index in retorno.data) {
              // PEGA O INDEX DA LINHA 
              var index2 = linhas.findIndex(item => item.id_pgto === retorno.data[index].id_pgto)

              // VERIFICA SE O VALOR ENCONTRADO
              if (index2 !== -1) {
                linhas[index2].valor_sum = (Number(linhas[index2].valor_sum) + Number(retorno.data[index].valor_sum)).toString()
              } else {
                linhas.push(retorno.data[index])
              }
            }
            
            // EXECUTA O CALLBACK RECEBIDO
            callback(linhas)
          }, this.demRelConsolidadoPgtoSetarStatusGeral)
        } else {
          callback(linhas)
        }
      },
      demRelConsolidadoPgtoMontarQueryGet: function (pag, rpp) {
        // CHAMA A FUNÇÃO PARA MONSTAR A ROTA
        this.demRelConsolidadoPgtoMontarRouter()

        // INICIA A QUERY
        var queryGet = { type: 'list', limit: { row: pag, qty: rpp } }

        // CHAMA A FUNÇÃO PARA MONTAR O FIELD
        queryGet.field = this.demRelConsolidadoPgtoMontarField()

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        queryGet.where = this.demRelConsolidadoPgtoMontarWhere()

        // SETA O ORDENAÇÃO DA PEQUISA
        queryGet.order = this.demRelConsolidadoPgtoMontarOrder()

        // CHAMA A FUNÇÃO PARA MONTAR O 
        queryGet.group = this.demRelConsolidadoPgtoMontarGroup()

        // RETORNA A QUERY MONTADA
        return queryGet
      },
      demRelConsolidadoPgtoPesquisar: function () {
        // SETA O STATUS DE CARREGANDO
        this.pesquisa = 'carregando'
    
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
          this.proRelEstTabReiniciar()
        } else {
          this.demRelConsolidadoPgtoSetarStatusGeral('')
        }
      },
      proRelEstTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proRelEstTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      demRelConsolidadoPgtoVerificarPermissao: function () {
        // VERIFICA O TIPO DE BUSCA QUE DEVE REALIZAR
        this.tpPesquisa = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, null, null, null, null, false) === true ? 'financeiro' : 'df'
        // this.tpPesquisa = 'df'

        // VERIFICA SE TEM PERMISSÃO VEICULO
        this.permissoes.vei = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PET
        this.permissoes.pet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PRODUTO
        this.permissoes.pro = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO SERVIÇO
        this.permissoes.ser = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true
      },
      demRelConsolidadoPgtoMontarRouter: function () {
        // INICIA A VARIAVEL
        var rota = ''

        // FAZ AS VERIFICAÇÕES
        switch (this.tpPesquisa) {
          case 'df':
            rota = '/venda/produto/df/pagamento/get'
            break

          case 'financeiro':
            rota = '/financeiro/get'
            break
        }

        // SETA O METHOD DA ROTA
        this.method = 'POST'

        // RETORNA A ROTA MONTADA
        this.router = rota
      },
      
      demRelConsolidadoPgtoMontarField: function (demanda = '') {
        // INICIA A VARIAVEL
        var field = {}

        // VERIFICA SE TEM DEMANDA
        if (demanda !== '') {
          demanda = '_' + demanda
        }

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (this.tpPesquisa) {
          case 'df':
            field = {
              id: null,
              cod_venda: { j: { vencimento: { a: 'vcto_pgto_ptbr' } } },
              // id_pgto: null,
              id_pgto: { j: { nome: null } },
              valor: { o: 'sum' }
            }
            break
          case 'df_grafico':
            field = {
              cod_venda: { a: '_REMOVER_', j: { vencimento: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] } } },
              // id_pgto: null,
              id_pgto: { j: { nome: null } },
              valor: { o: 'sum' }
            }
            break

          case 'financeiro':
            field = {
              id: null,
              vcto_pgto: null,
              // id_pgto: null,
              id_pgto: { j: { nome: null } },
              valor: { o: 'sum' }
            }
            break
          case 'financeiro_grafico':
            field = {
              vcto_pgto: { a: 'vcto', o: [ 'day', 'month', 'year', 'week' ] },
              // id_pgto: null,
              id_pgto: { j: { nome: null } },
              valor: { o: 'sum' }
            }
            break
        }

        // RETORNA A ROTA MONTADA
        return field
      },
      demRelConsolidadoPgtoMontarWhere: function (pdv = false) {
        // IMPORTA BIBLIOTECA DEPENDENTE
        var moment = require('moment')

        // INICIA O WHERE QUE SERÁ REALIZADO
        var where = {}

        // INICIA O WHERE
        where = { aAnd: [] }

        // SETA O WHERE RECEBIDO
        var whereCon = []
        var wherePet = []
        var whereVei = []
        var whereBus = []
        var index1 = ''
        var buscaV = []

        // SETA O FILTRO PARA EXCLUIR VENDAS PDV COM FECHAMENTO
        if (pdv === true) {
          buscaV.push({ m: 'venda', f: 'pdv_status', o: '=', v: '0' })
        }

        // VERIFICA SE TEM PARAMETROS DE BUSCA
        if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
          // PEGA OS FILTROS SELECIONADOS
          var filtros = JSON.parse(JSON.stringify(this.cpntFiltros))

          // VERIFICA O TIPO DE FILTRO
          if (this.tpPesquisa !== 'financeiro' && pdv === false) {
            // PEGA APENAS OS REGISTRO QUE NÃO FOI EXCLUIDO
            where.aAnd.push({ f: 'status', o: '<>', v: '3' })
              
            // RODA A MONTAGEM DO WHERE
            for (index1 in filtros) {
              // CONVERTE O VALOR RECEBIDO
              if (filtros[index1].o === '%') {
                filtros[index1].o = 'like'
              }

              switch (filtros[index1].f) {
                case 'codigo':
                  where.aAnd.push({ m: 'venda', f: 'cod_venda', o: 'in', v: filtros[index1].v })
                  break
  
                case 'status':
                  where.aAnd.push({ m: 'venda', f: 'status', o: '=', v: (filtros[index1].v === 'demanda' ? '2' : '1') })
                  break
  
                case 'last_at':
                  // VERIFICA SE TEM QUE GERAR O VALOR
                  if ([ '', null, undefined ].indexOf(filtros[index1].v._dataIni) !== -1) {
                    filtros[index1].v._dataIni = moment(filtros[index1].v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  }
                  if ([ '', null, undefined ].indexOf(filtros[index1].v._dataFim) !== -1) {
                    filtros[index1].v._dataFim = moment(filtros[index1].v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  }
  
                  // SETA O WHERE QUE DEVE REALIZAR
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ aAnd: [
                      { m: 'venda', f: 'vencimento', o: '>=', v: filtros[index1].v._dataIni + ' 00:00:00' },
                      { m: 'venda', f: 'vencimento', o: '<=', v: filtros[index1].v._dataFim + ' 23:59:59' }
                    ] })
                  } else if (filtros[index1].o === '<>') {
                    where.aAnd.push({ aOr: [
                      { m: 'venda', f: 'vencimento', o: '<', v: filtros[index1].v._dataIni + ' 00:00:00' },
                      { m: 'venda', f: 'vencimento', o: '>', v: filtros[index1].v._dataFim + ' 23:59:59' }
                    ] })
                  } else if ([ '<=' ].indexOf(filtros[index1].o) !== -1) {
                    where.aAnd.push({ aOr: [
                      { m: 'venda', f: 'vencimento', o: filtros[index1].o, v: filtros[index1].v._dataFim + ' 23:59:59' }
                    ] })
                  } else if ([ '>=' ].indexOf(filtros[index1].o) !== -1) {
                    where.aAnd.push({ aOr: [
                      { m: 'venda', f: 'vencimento', o: '>', v: filtros[index1].v._dataIni + ' 00:00:00' }
                    ] })
                  }
                  break
  
                case 'last_user':
                  where.aAnd.push({ m: 'venda', f: 'updated_user', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'financeiro':
                  where.aAnd.push({ m: 'venda', f: 'status_fin', o: filtros[index1].o, v: (filtros[index1].v === 's' ? '1' : '0') })
                  break
  
                case 'id_con_nome':
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    whereCon.push(Object.assign(filtros[index1], { m: 'contato', f: 'nome' }))
                  }
                  break
  
                case 'id_con_cnpj':
                case 'id_con_cpf':
                  whereCon.push({ m: 'contato', f: 'cnpj_cpf', o: filtros[index1].o, v: filtros[index1].v })
                  break
  
                case 'id_con_telefone':
                  whereCon.push({ aOr: [ 
                    { m: 'contato', f: 'tel_res', o: filtros[index1].o, v: filtros[index1].v },
                    { m: 'contato', f: 'tel_com', o: filtros[index1].o, v: filtros[index1].v },
                    { m: 'contato', f: 'tel_cel', o: filtros[index1].o, v: filtros[index1].v }
                  ] })
                  break
  
                case 'id_con_email':
                  whereCon.push({ m: 'contato', f: 'email', o: filtros[index1].o, v: filtros[index1].v })
                  break
  
                case 'id_con_estado':
                  whereCon.push({ m: 'contato', f: 'id_estado', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'id_con_cidade':
                  whereCon.push({ m: 'contato', f: 'id_cidade', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'id_con_tp_con':
                  whereCon.push({ m: 'contato', f: 'id_tp_con', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'id_con_pessoa':
                  whereCon.push({ m: 'contato', f: 'pessoa', o: filtros[index1].o, v: filtros[index1].v })
                  break
  
                case 'id_pet_nome':
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    wherePet.push(Object.assign(filtros[index1], { m: 'pet', f: 'nome' }))
                  }
                  break
  
                case 'id_pet_sexo':
                  wherePet.push({ m: 'pet', f: 'sexo', o: filtros[index1].o, v: (filtros[index1].v === 'n' ? '' : filtros[index1].v) })
                  break
  
                case 'id_pet_especie':
                  wherePet.push({ m: 'pet', f: 'id_pet_subespecie', o: 'in', r: 'id', q: {
                    model: 'pet_subespecie',
                    where: { f: 'id_especie', o: '=', v: filtros[index1].v.join() }
                  } })
                  break
  
                case 'id_pet_raca':
                  wherePet.push({ m: 'pet', f: 'id_pet_subespecie', o: filtros[index1].o, v: filtros[index1].v.join() })
                  break
  
                case 'id_vei_placa':
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    whereVei.push(Object.assign(filtros[index1], { m: 'veiculo', f: 'placa' }))
                  }
                  break
  
                case 'id_vei_modelo':
                  if (this.$store.state.flagBuscaVei === true) {
                    whereVei.push({ m: 'veiculo', f: 'ref_modelo', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    whereVei.push({ m: 'veiculo', f: 'id_mod', o: 'in', v: filtros[index1].v.join() })
                  }
                  break
  
                case 'id_vei_marca':
                  if (this.$store.state.flagBuscaVei === true) {
                    whereVei.push({ m: 'veiculo', f: 'ref_modelo', o: 'in', r: 'id', q: {
                      model: 'vei_modelo',
                      where: { f: 'id_marca', o: '=', v: filtros[index1].v.join() }
                    } })
                  } else {
                    whereVei.push({ m: 'veiculo', f: 'id_mar', o: 'in', v: filtros[index1].v.join() })
                  }
                  break
  
                case 'pco':
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ m: 'venda', f: 'id_pco_item', o: 'in', r: 'id', q: {
                      model: 'pco_item',
                      where: { aAnd: [
                        { f: 'id_pco_status_item', o: 'in', v: filtros[index1].v.join(',') },
                        { f: 'selecionado', o: '=', v: '1' }
                      ] }
                    } })
                  } else {
                    where.aAnd.push({ m: 'venda', f: 'id_pco_item', o: 'in', r: 'id', q: {
                      model: 'pco_item',
                      where: { aAnd: [
                        { f: 'id_pco_status_item', o: 'notIn', v: filtros[index1].v.join(',') },
                        { f: 'selecionado', o: '=', v: '1' }
                      ] }
                    } })
                  }
                  break
  
                case 'NFeFornecedor':
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_tp', o: (filtros[index1].v === 's' ? '=' : '<>' ), v: 'NFeFornecedor' })
                  } else {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_n', o: '=', v: filtros[index1].v })
                  }
                  break
  
                case 'NFCeFornecedor':
                  if (filtros[index1].o === '=') {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_tp', o: (filtros[index1].v === 's' ? '=' : '<>' ), v: 'NFCeFornecedor' })
                  } else {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_n', o: '=', v: filtros[index1].v })
                  }
                  break
  
                case 'NFe':
                case 'NFCe':
                  if (filtros[index1].o === 'ope') {
                    where.aAnd.push({ aAnd: [
                      { m: 'venda', f: 'p_doc_docs', o: 'isNotNull' },
                      { m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' },
                      { m: 'venda', f: 'p_doc_ope', o: '=', v: filtros[index1].v },
                    ] })
                  } else if (filtros[index1].v === 'N' || filtros[index1].v.indexOf('N') !== -1) {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '=', v: '0' })
                  } else if (filtros[index1].o === 'sit') {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: 'in', r: 'id', q: {
                      model: 'doc_fiscal',
                      where: { aAnd: [
                        { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: filtros[index1].f },
                        { m: 'doc_fiscal', f: 'SitCodigo', o: 'in', v: filtros[index1].v.join(',') }
                      ] }
                    } })
                  } else {
                    where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: 'in', r: 'id', q: {
                      model: 'doc_fiscal',
                      where: { aAnd: [
                        { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: filtros[index1].f },
                        { m: 'doc_fiscal', f: 'DocNumero', o: 'in', v: filtros[index1].v }
                      ] }
                    } })
                  }
  
                  // SETA O TIPO DE DOCUMENTO
                  where.aAnd.push({ m: 'venda', f: 'p_doc_tp', o: '=', v: filtros[index1].f })
                  break
    
                case 'busca':
                  if (isNaN(filtros[index1].v) === false) {
                    where.aAnd.push({ m: 'venda', o: 's.ft', v: filtros[index1].v })
                  } else {
                    // SETA OS DADOS QUE SERÁ BUSCADO NO MODEL DE VENDA
                    whereBus = { aOr: [ { o: 's.ft', v: filtros[index1].v } ] }
        
                    // SETA A INFORMAÇÃO DE BUSCA
                    if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true) {
                      whereBus.aOr.push({ m: 'veiculo',    o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_mod',    o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_mar',    o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_marca',  o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_modelo', o: 's.ft', v: filtros[index1].v })
                    }
        
                    // SETA A INFORMAÇÃO DE BUSCA
                    if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true) {
                      whereBus.aOr.push({ m: 'pet', o: 's.ft', v: filtros[index1].v })
                    }
        
                    // ADICIONA A BUSCA DE CONTATO
                    whereBus.aOr.push({ m: 'contato', o: 's.ft', v: filtros[index1].v })

                    // SETA O WHERE MONTADO PARA BUSCA
                    where.aAnd.push(whereBus)
                  }
                  break
  
                case 'alias':
                  if (filtros[index1].v === '0') {
                    where.aAnd.push({ m: 'venda', f: 'id_alias', o: 'isNull' })
                  } else {
                    where.aAnd.push({ m: 'venda', f: 'id_alias', o: '=', v: filtros[index1].v })
                  }
                  break
              }
            }

            // SETA O WHERE DO CONTATO
            if (whereCon.length >= 1) {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', r: 'id', q: {
                model: 'contato',
                where: { aAnd: whereCon }
              } })
            }

            // SETA O WHERE DO VEICULO
            if (whereVei.length >= 1) {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', r: 'id', q: {
                model: 'veiculo',
                where: { aAnd: whereVei }
              } })
            }

            // SETA O WHERE DO VEICULO
            if (wherePet.length >= 1) {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', r: 'id', q: {
                model: 'pet',
                where: { aAnd: wherePet }
              } })
            }

            // SETA O STATUS DA VENDA
            where.aAnd.push({ m: 'venda', f: 'status', o: '<>', v: '3' })
            where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '' })
            where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' })
            where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: 'isNotNull' })
          } else {
            // PEGA APENAS OS REGISTRO QUE NÃO FOI EXCLUIDO
            if (pdv === false) {
              where.aAnd.push({ f: 'status', o: '<>', v: '3' })
              where.aAnd.push({ f: 'id_modulo', o: '=', v: '10' })
            }
              
            // RODA A MONTAGEM DO WHERE
            for (index1 in filtros) {
              // CONVERTE O VALOR RECEBIDO
              if (filtros[index1].o === '%') {
                filtros[index1].o = 'like'
              }

              switch (filtros[index1].f) {
                case 'codigo':
                  buscaV.push({ m: 'venda', f: 'cod_venda', o: 'in', v: filtros[index1].v })
                  break
  
                case 'status':
                  buscaV.push({ m: 'venda', f: 'status', o: '=', v: (filtros[index1].v === 'demanda' ? '2' : '1') })
                  break
  
                case 'last_at':
                  // VERIFICA SE TEM QUE GERAR O VALOR
                  if ([ '', null, undefined ].indexOf(filtros[index1].v._dataIni) !== -1) {
                    filtros[index1].v._dataIni = moment(filtros[index1].v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  }
                  if ([ '', null, undefined ].indexOf(filtros[index1].v._dataFim) !== -1) {
                    filtros[index1].v._dataFim = moment(filtros[index1].v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  }

                  // where.aAnd.push({ aAnd: [
                  //   { f: 'vcto_pgto', o: '>=', v: this.filtros.dat._dataIni },
                  //   { f: 'vcto_pgto', o: '<=', v: this.filtros.dat._dataFim }
                  // ] })
  
                  // SETA O WHERE QUE DEVE REALIZAR
                  if (pdv === false) {
                    if (filtros[index1].o === '=') {
                      where.aAnd.push({ aAnd: [
                        { f: 'vcto_pgto', o: '>=', v: filtros[index1].v._dataIni + ' 00:00:00' },
                        { f: 'vcto_pgto', o: '<=', v: filtros[index1].v._dataFim + ' 23:59:59' }
                      ] })
                    } else if (filtros[index1].o === '<>') {
                      where.aAnd.push({ aOr: [
                        { f: 'vcto_pgto', o: '<', v: filtros[index1].v._dataIni + ' 00:00:00' },
                        { f: 'vcto_pgto', o: '>', v: filtros[index1].v._dataFim + ' 23:59:59' }
                      ] })
                    } else if ([ '<=' ].indexOf(filtros[index1].o) !== -1) {
                      where.aAnd.push({ aOr: [
                        { f: 'vcto_pgto', o: filtros[index1].o, v: filtros[index1].v._dataFim + ' 23:59:59' }
                      ] })
                    } else if ([ '>=' ].indexOf(filtros[index1].o) !== -1) {
                      where.aAnd.push({ aOr: [
                        { f: 'vcto_pgto', o: '>', v: filtros[index1].v._dataIni + ' 00:00:00' }
                      ] })
                    }
                  } else {
                    if (filtros[index1].o === '=') {
                      buscaV.push({ aAnd: [
                        { m: 'venda', f: 'vencimento', o: '>=', v: filtros[index1].v._dataIni + ' 00:00:00' },
                        { m: 'venda', f: 'vencimento', o: '<=', v: filtros[index1].v._dataFim + ' 23:59:59' }
                      ] })
                    } else if (filtros[index1].o === '<>') {
                      buscaV.push({ aOr: [
                        { m: 'venda', f: 'vencimento', o: '<', v: filtros[index1].v._dataIni + ' 00:00:00' },
                        { m: 'venda', f: 'vencimento', o: '>', v: filtros[index1].v._dataFim + ' 23:59:59' }
                      ] })
                    } else if ([ '<=' ].indexOf(filtros[index1].o) !== -1) {
                      buscaV.push({ aOr: [
                        { m: 'venda', f: 'vencimento', o: filtros[index1].o, v: filtros[index1].v._dataFim + ' 23:59:59' }
                      ] })
                    } else if ([ '>=' ].indexOf(filtros[index1].o) !== -1) {
                      buscaV.push({ aOr: [
                        { m: 'venda', f: 'vencimento', o: '>', v: filtros[index1].v._dataIni + ' 00:00:00' }
                      ] })
                    }

                  }
                  break
  
                case 'last_user':
                  buscaV.push({ m: 'venda', f: 'updated_user', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'financeiro':
                  buscaV.push({ m: 'venda', f: 'status_fin', o: filtros[index1].o, v: (filtros[index1].v === 's' ? '1' : '0') })
                  break
  
                case 'id_con_nome':
                  if (filtros[index1].o === '=') {
                    buscaV.push({ m: 'venda', f: 'id_con', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    whereCon.push(Object.assign(filtros[index1], { m: 'contato', f: 'nome' }))
                  }
                  break
  
                case 'id_con_cnpj':
                case 'id_con_cpf':
                  whereCon.push({ m: 'contato', f: 'cnpj_cpf', o: filtros[index1].o, v: filtros[index1].v })
                  break
  
                case 'id_con_telefone':
                  whereCon.push({ aOr: [ 
                    { m: 'contato', f: 'tel_res', o: filtros[index1].o, v: filtros[index1].v },
                    { m: 'contato', f: 'tel_com', o: filtros[index1].o, v: filtros[index1].v },
                    { m: 'contato', f: 'tel_cel', o: filtros[index1].o, v: filtros[index1].v }
                  ] })
                  break
  
                case 'id_con_email':
                  whereCon.push({ m: 'contato', f: 'email', o: filtros[index1].o, v: filtros[index1].v })
                  break
  
                case 'id_con_estado':
                  whereCon.push({ m: 'contato', f: 'id_estado', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'id_con_cidade':
                  whereCon.push({ m: 'contato', f: 'id_cidade', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'id_con_tp_con':
                  whereCon.push({ m: 'contato', f: 'id_tp_con', o: filtros[index1].o, v: filtros[index1].v.join(',') })
                  break
  
                case 'id_con_pessoa':
                  whereCon.push({ m: 'contato', f: 'pessoa', o: filtros[index1].o, v: filtros[index1].v })
                  break
  
                case 'id_pet_nome':
                  if (filtros[index1].o === '=') {
                    buscaV.push({ m: 'venda', f: 'id_pet', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    wherePet.push(Object.assign(filtros[index1], { m: 'pet', f: 'nome' }))
                  }
                  break
  
                case 'id_pet_sexo':
                  wherePet.push({ m: 'pet', f: 'sexo', o: filtros[index1].o, v: (filtros[index1].v === 'n' ? '' : filtros[index1].v) })
                  break
  
                case 'id_pet_especie':
                  wherePet.push({ m: 'pet', f: 'id_pet_subespecie', o: 'in', r: 'id', q: {
                    model: 'pet_subespecie',
                    where: { f: 'id_especie', o: '=', v: filtros[index1].v.join() }
                  } })
                  break
  
                case 'id_pet_raca':
                  wherePet.push({ m: 'pet', f: 'id_pet_subespecie', o: filtros[index1].o, v: filtros[index1].v.join() })
                  break
  
                case 'id_vei_placa':
                  if (filtros[index1].o === '=') {
                    buscaV.push({ m: 'venda', f: 'id_vei', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    whereVei.push(Object.assign(filtros[index1], { m: 'veiculo', f: 'placa' }))
                  }
                  break
  
                case 'id_vei_modelo':
                  if (this.$store.state.flagBuscaVei === true) {
                    whereVei.push({ m: 'veiculo', f: 'ref_modelo', o: 'in', v: filtros[index1].v.join() })
                  } else {
                    whereVei.push({ m: 'veiculo', f: 'id_mod', o: 'in', v: filtros[index1].v.join() })
                  }
                  break
  
                case 'id_vei_marca':
                  if (this.$store.state.flagBuscaVei === true) {
                    whereVei.push({ m: 'veiculo', f: 'ref_modelo', o: 'in', r: 'id', q: {
                      model: 'vei_modelo',
                      where: { f: 'id_marca', o: '=', v: filtros[index1].v.join() }
                    } })
                  } else {
                    whereVei.push({ m: 'veiculo', f: 'id_mar', o: 'in', v: filtros[index1].v.join() })
                  }
                  break
  
                case 'pco':
                  if (filtros[index1].o === '=') {
                    buscaV.push({ m: 'venda', f: 'id_pco_item', o: 'in', r: 'id', q: {
                      model: 'pco_item',
                      where: { aAnd: [
                        { f: 'id_pco_status_item', o: 'in', v: filtros[index1].v.join(',') },
                        { f: 'selecionado', o: '=', v: '1' }
                      ] }
                    } })
                  } else {
                    buscaV.push({ m: 'venda', f: 'id_pco_item', o: 'in', r: 'id', q: {
                      model: 'pco_item',
                      where: { aAnd: [
                        { f: 'id_pco_status_item', o: 'notIn', v: filtros[index1].v.join(',') },
                        { f: 'selecionado', o: '=', v: '1' }
                      ] }
                    } })
                  }
                  break
  
                case 'NFeFornecedor':
                  if (filtros[index1].o === '=') {
                    buscaV.push({ m: 'venda', f: 'p_doc_tp', o: (filtros[index1].v === 's' ? '=' : '<>' ), v: 'NFeFornecedor' })
                  } else {
                    buscaV.push({ m: 'venda', f: 'p_doc_n', o: '=', v: filtros[index1].v })
                  }
                  break
  
                case 'NFCeFornecedor':
                  if (filtros[index1].o === '=') {
                    buscaV.push({ m: 'venda', f: 'p_doc_tp', o: (filtros[index1].v === 's' ? '=' : '<>' ), v: 'NFCeFornecedor' })
                  } else {
                    buscaV.push({ m: 'venda', f: 'p_doc_n', o: '=', v: filtros[index1].v })
                  }
                  break
  
                case 'NFe':
                case 'NFCe':
                  if (filtros[index1].o === 'ope') {
                    buscaV.push({ aAnd: [
                      { m: 'venda', f: 'p_doc_docs', o: 'isNotNull' },
                      { m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' },
                      { m: 'venda', f: 'p_doc_ope', o: '=', v: filtros[index1].v },
                    ] })
                  } else if (filtros[index1].v === 'N' || filtros[index1].v.indexOf('N') !== -1) {
                    buscaV.push({ m: 'venda', f: 'p_doc_docs', o: '=', v: '0' })
                  } else if (filtros[index1].o === 'sit') {
                    buscaV.push({ m: 'venda', f: 'p_doc_docs', o: 'in', r: 'id', q: {
                      model: 'doc_fiscal',
                      where: { aAnd: [
                        { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: filtros[index1].f },
                        { m: 'doc_fiscal', f: 'SitCodigo', o: 'in', v: filtros[index1].v.join(',') }
                      ] }
                    } })
                  } else {
                    buscaV.push({ m: 'venda', f: 'p_doc_docs', o: 'in', r: 'id', q: {
                      model: 'doc_fiscal',
                      where: { aAnd: [
                        { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: filtros[index1].f },
                        { m: 'doc_fiscal', f: 'DocNumero', o: 'in', v: filtros[index1].v }
                      ] }
                    } })
                  }
  
                  // SETA O TIPO DE DOCUMENTO
                  buscaV.push({ m: 'venda', f: 'p_doc_tp', o: '=', v: filtros[index1].f })
                  break
    
                case 'busca':
                  if (isNaN(filtros[index1].v) === false) {
                    buscaV.push({ m: 'venda', o: 's.ft', v: filtros[index1].v })
                  } else {
                    // SETA OS DADOS QUE SERÁ BUSCADO NO MODEL DE VENDA
                    whereBus = { aOr: [ { o: 's.ft', v: filtros[index1].v } ] }
        
                    // SETA A INFORMAÇÃO DE BUSCA
                    if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true) {
                      whereBus.aOr.push({ m: 'veiculo',    o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_mod',    o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_mar',    o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_marca',  o: 's.ft', v: filtros[index1].v })
                      whereBus.aOr.push({ m: 'vei_modelo', o: 's.ft', v: filtros[index1].v })
                    }
        
                    // SETA A INFORMAÇÃO DE BUSCA
                    if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true) {
                      whereBus.aOr.push({ m: 'pet', o: 's.ft', v: filtros[index1].v })
                    }
        
                    // ADICIONA A BUSCA DE CONTATO
                    whereBus.aOr.push({ m: 'contato', o: 's.ft', v: filtros[index1].v })

                    // SETA O WHERE MONTADO PARA BUSCA
                    buscaV.push(whereBus)
                  }
                  break
  
                case 'alias':
                  if (filtros[index1].v === '0') {
                    buscaV.push({ m: 'venda', f: 'id_alias', o: 'isNull' })
                  } else {
                    buscaV.push({ m: 'venda', f: 'id_alias', o: '=', v: filtros[index1].v })
                  }
                  break
              }
            }            

            // SETA O WHERE DO CONTATO
            if (whereCon.length >= 1) {
              buscaV.push({ m: 'venda', f: 'id_con', o: 'in', r: 'id', q: {
                model: 'contato',
                where: { aAnd: whereCon }
              } })
            }

            // SETA O WHERE DO VEICULO
            if (whereVei.length >= 1) {
              buscaV.push({ m: 'venda', f: 'id_vei', o: 'in', r: 'id', q: {
                model: 'veiculo',
                where: { aAnd: whereVei }
              } })
            }

            // SETA O WHERE DO VEICULO
            if (wherePet.length >= 1) {
              buscaV.push({ m: 'venda', f: 'id_pet', o: 'in', r: 'id', q: {
                model: 'pet',
                where: { aAnd: wherePet }
              } })
            }
  
            // ADICOINA O WHERE NA PESQUISA
            if (pdv === true) {
              where.aAnd = where.aAnd.concat(buscaV)
            } else if (buscaV.length >= 1) {
              where.aAnd.push({ aAnd: [
                { f: 'id_modulo', o: '=', v: '10' },
                { f: 'id_mod_reg', o: 'in', r: 'cod_venda', q: {
                  model: 'venda',
                  where: { aAnd: buscaV }
                } }
              ] })
            }
          }
        } else {  
          // VERIFICA O TIPO DE REGISTRO QUE DEVE BUSCAR
          if (this.tpPesquisa !== 'financeiro') {
            // SETA O STATUS DA VENDA
            where.aAnd.push({ m: 'venda', f: 'status', o: '<>', v: '3' })
            where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '' })
            where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' })
            where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: 'isNotNull' })
    
            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }
    
            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '0' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }
    
            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'isNull' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }
    
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
          } else {
            // PEGA APENAS OS REGISTRO QUE NÃO FOI EXCLUIDO
            if (pdv === false) {
              where.aAnd.push({ f: 'status', o: '<>', v: '3' })
            } else {
              buscaV.push({ m: 'venda', f: 'status', o: '<>', v: '3' })
            }
  
            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              buscaV.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }
    
            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              buscaV.push({ m: 'venda', f: 'id_vei', o: '=', v: '0' })
            } else if (this.filtros.vei !== '') {
              buscaV.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }
    
            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              buscaV.push({ m: 'venda', f: 'id_pet', o: 'isNull' })
            } else if (this.filtros.pet !== '') {
              buscaV.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }
  
            // SETA A\ BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              if (pdv === true) {
                buscaV.push({ aAnd: [
                  { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni },
                  { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim }
                ] })
              } else {                
                where.aAnd.push({ aAnd: [
                  { f: 'vcto_pgto', o: '>=', v: this.filtros.dat._dataIni },
                  { f: 'vcto_pgto', o: '<=', v: this.filtros.dat._dataFim }
                ] })
              }
            }

            // ADICOINA O WHERE NA PESQUISA
            if (buscaV.length >= 1) {
              if (pdv === true) {
                where.aAnd.push({ aAnd: [
                  { f: 'cod_venda', o: 'in', r: 'cod_venda', q: {
                    model: 'venda',
                    where: { aAnd: buscaV }
                  } }
                ] })
              } else {
                where.aAnd.push({ aAnd: [
                  { f: 'id_modulo', o: '=', v: '10' },
                  { f: 'id_mod_reg', o: 'in', r: 'cod_venda', q: {
                    model: 'venda',
                    where: { aAnd: buscaV }
                  } }
                ] })
              }
            }
            
          }
        }        

        // RETORNA O WHERE MONTADO
        return where
      },
      demRelConsolidadoPgtoMontarGroup: function () {
        // INICIA A VARIAVEL
        var group = []

        // FAZ AS VERIFICAÇÕES
        switch (this.tpPesquisa) {
          case 'df':
            group = [ 'id_pgto' ]
            break

          case 'financeiro':
            group = [ 'id_pgto' ]
            break
        }

        // RETORNA O VALOR MONTADO
        return group
      },
      demRelConsolidadoPgtoMontarOrder: function () {
        // INICIA A VARIAVEL
        var order = {}

        // FAZ AS VERIFICAÇÕES
        switch (this.tpPesquisa) {
          case 'df':
            // order = { 'vencimento_ptbr': 'desc' }
            order = { 'id_pgto_nome': 'desc' }
            break

          case 'financeiro':
            order = { 'id_pgto_nome': 'desc' }
            break
        }

        // RETORNA O VALOR MONTADO
        return order
      },
      demRelConsolidadoPgtoTabSetarLinhas: function (vetor) {
        // INICIA A VARIAVEL
        var total = 0

        // CONVERTE EM VETOR OS VALORES
        for (var indexV in vetor) {
          // SOMA O VALOR NO TOTAL
          total += Number(vetor[indexV].valor_sum)

          // PROCURA O VALOR NO VETOR
          vetor[indexV]._valor_sum = this.$store.state.FUN_MASK_VALOR('valorMoeda', vetor[indexV].valor_sum)
        }

        // SETA A LINHA TOTAL
        if (vetor.length >= 1) {
          vetor.push({ id: 'total', id_pgto_nome: 'Total', valor_sum: total, _valor_sum: this.$store.state.FUN_MASK_VALOR('valorMoeda', total) })
        }

        // SETA OS VALORES RECEBIDOS
        this.linhas = vetor

        // CHAMA A FUNÇÃO PARA SETAR OS VALORES
        setTimeout(() => { this.demRelConsolidadoPgtoMontarGrafico(vetor) }, 0)

        // SETA O STATUS DE CARREGANDO
        this.pesquisa = this.pesquisa === 'carregando' ? '' : this.pesquisa

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelConsolidadoPgtoMontarGrafico: function (retorno) {
        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }

        // LIMPA O GRAFICO
        this.grafico = null

        // IMPORTA A FUNÇAO
        const FUN_RANDOM_COLOR = require('@/assets/js/Funcoes-Gerais.js').FUN_RANDOM_COLOR

        // INICIA O VETOR
        var cor = ''
        var colunas = []
        var valores = []

        // GERA AS NOVAS CORRES PARA OS CAMPOS
        cor = FUN_RANDOM_COLOR()

        // SETA O VETOR DE DADOS
        var item = {
          // label: retorno[index].nome,
          label: 'Total',
          data: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 1
        }

        // SETA OS IDS SOLICITADOS
        for (var index in retorno) {
          if (retorno[index].id !== 'total') {
            // SETA OS DADOS DA COLUNA
            colunas.push(retorno[index].id_pgto_nome)
  
            // GERA AS NOVAS CORRES PARA OS CAMPOS
            cor = FUN_RANDOM_COLOR()
  
            // ADICIONA AS CORES PARA CADA TIPO
            item.backgroundColor.push(cor[0])
            item.borderColor.push(cor[1])
  
            // ADICIONA O VALOR MONTADO
            item.data.push(Number((Number(retorno[index].valor_sum) / 100).toFixed(2)))
          }
        }
        // ADICIONA O VALOR NO VETOR
        valores.push(item)

        // MOSTRA O GRAFICO
        this.grafico = ''

        // CHAMA A FUNÇÃO PARA INICIAR O GRAFICO
        this.demRelConsolidadoPgtoIniciarGrafico(colunas, valores)
      },
      demRelConsolidadoPgtoIniciarGrafico: function (colunas, valores, tentativa = 0) {
        if (tentativa <= 10 && this.$refs.grafico === undefined) {
          setTimeout(() => { this.demRelConsolidadoPgtoIniciarGrafico(colunas, valores, (tentativa + 1)) }, 500)
        } else if (this.$refs.grafico !== undefined) {
          // IMPORTA A FUNÇÃO
          const Chart = require('chart.js')
  
          // SETA O GRAFICO NA TELA
          this.grafico = new Chart(this.$refs.grafico, {
            type: 'bar',
              data: {
              labels: colunas,
              datasets: valores
            },
            options: {
              responsive: true,
              legend: {
                display: false
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      minRotation: 45,
                      callback: function(val) {
                        // PEGAR PARTE DO NOME DO CONTATO
                        val = val.toUpperCase()
                        if (val.length >= 20) {
                          val = val.substring(0, 20) + '...'
                        }
                        
                        // RETORNA O VALOR MONTADO
                        return val
                      }
                    },
                    scaleLabel: {
                      display: false
                    }
                  }
                ],
                yAxes: [ 
                  {
                    ticks: {
                      beginAtZero: true,
                      callback: (label) => {
                        return this.$store.state.FUN_MASK_VALOR('valorMoeda', (label * 100).toFixed(0).toString())
                      }
                    }
                  }
                ]
              },
              tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                  label: (item) => {
                    return valores[item.datasetIndex].label + ': R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())
                  }
                }
              }
            }
          })
        }
      },
      demRelConsolidadoPgtoBuscarTipoNF: function (callback) {
        // INICIA A VARIAVEL DE OPÇÕES
        var options = [
          { id: '0', nome: 'Dia' },
          { id: '1', nome: 'Mês' },
          { id: '2', nome: 'Ano' },
          { id: '3', nome: 'Tipo Pagamento' }
        ]

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      demRelConsolidadoPgtoMontarWhereFiltro: function (campo) {
        // INICIA A VARIAVEL WHERE
        var where = {} 
        
        // SETA O VALOR DE CADA CAMPO
        switch (campo) {
          case 'pro':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.pro_cat.join() })
            }

            // VERIFICA SE TEM QUE FILTRAR MARCA
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ f: 'id_mar', o: '=', v: this.filtros.pro_mar.join() })
            }
            break

          case 'ser':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.ser_cat.join() })
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return where
      },
      demRelConsolidadoPgtoAtualizarFiltro: function (value, chave) {
        // SETA O NOVO VALOR DO FILTRO
        this.filtros[chave] = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    computed: {
      demRelConsolidadoPgtoContarColunasLinha1: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 1

        // VERIFICA SE TEM O PACOTE VEICULO
        qtde = (qtde + (this.permissoes.vei === true ? 1 : 0))

        // VERIFICA SE TEM O PACOTE PET
        qtde = (qtde + (this.permissoes.pet === true ? 1 : 0))

        // RETORNA O VALOR
        return qtde
      }
    }
  }
</script>
